import React, {useEffect, useState, useContext} from 'react';
import { apigeeEndpoint } from '../apis';
import { AmendTfaAncillaryRequest, AmendTfaAncillaryResponse } from '@tff/types/tff/tfa-amend-ancillary-service';
import { LoadingContext } from '../contexts/LoadingContextProvider';

export type TypeOfStatus = 'IN_ANCILLARY' | 'CONFIRMED' | 'FAILURE';

export type UseSsrResponse = {
  ssrResponse?: AmendTfaAncillaryResponse;
  ssrStatus: TypeOfStatus;
  ssrError?: Error | undefined;
  setSsrUpdateRequest: (ssrUpdateRequest: AmendTfaAncillaryRequest) => void;
};

export const useAddSsr = (): UseSsrResponse => {
  const { showLoading, closeLoading } = useContext(LoadingContext);

  const [ssrStatus, setSsrStatus] = React.useState<TypeOfStatus>('IN_ANCILLARY');
  const [ssrResponse, setSsrResponse] = React.useState<AmendTfaAncillaryResponse>();
  const [ssrError, setSsrError] = React.useState<Error>();
  const [ssrUpdateRequest, setSsrUpdateRequest] = useState<AmendTfaAncillaryRequest>();
  useEffect(() => {
    const ssrFromBackend = async (ssrUpdateRequest: AmendTfaAncillaryRequest): Promise<void> => {
      try {
        setSsrStatus('IN_ANCILLARY');
        showLoading('Please Wait');

        const response = await apigeeEndpoint.post('ancillary-amend', ssrUpdateRequest);

        if (response.data.status === 'SUCCESS') {
          if (response.data.body != undefined) {
            setSsrStatus('CONFIRMED');
            setSsrResponse(response.data.data ?? response.data);
          }
          closeLoading();
        } else {
          setSsrStatus('FAILURE');
          setSsrError(response.data.error);
          closeLoading();
        }
      } catch (error) {
        setSsrStatus('FAILURE');
        closeLoading();
      }
    };

    if (ssrUpdateRequest) {
      void ssrFromBackend(ssrUpdateRequest);
    }
  }, [ssrUpdateRequest]);

  return {
    setSsrUpdateRequest,
    ssrError,
    ssrResponse,
    ssrStatus,
  };
};
